(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1300],{

/***/ 92039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M10 3.75a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 3.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 8.75Zm0 5a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 10 13.75Z",
    fill: "currentColor"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgDotsVertical);

/***/ }),

/***/ 20168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ HeaderNavigation; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95571);
/* harmony import */ var _header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);






const HeaderNavigation = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header_navigation), props.sticky && (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().menu),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inner),
                children: props.menu.map((it, key)=>{
                    const active = it.exact ? router.asPath === it.href : router.asPath.startsWith(it.href);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: it.href,
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_header_navigation_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                        children: it.label
                    }, it.href);
                })
            })
        })
    });
};
HeaderNavigation.defaultProps = {};


/***/ }),

/***/ 80665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useMyPermissions; }
/* harmony export */ });
/* unused harmony export convertPermissions */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22823);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94840);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32636);


const convertPermissions = (roleType, permissions)=>{
    const set = new Set(permissions);
    const isOwner = roleType === shared_api__WEBPACK_IMPORTED_MODULE_1__/* .CompanyEmployeeRoleType.OWNER */ .Or.OWNER;
    return {
        finances: {
            budgets: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            plannings: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            fundingRequests: {
                create: true,
                readAll: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_READ_ALL */ .Mn.CLAIM_READ_ALL),
                acceptOrDecline: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING */ .Mn.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE),
                close: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE) || set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF),
                pay: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF)
            },
            funds: {
                withdraw: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_WITHDRAW */ .Mn.FUND_WITHDRAW),
                deposit: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_DEPOSIT */ .Mn.FUND_DEPOSIT),
                readProtected: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_SECURED_READ */ .Mn.FUND_SECURED_READ)
            }
        },
        company: {
            general: {
                update: isOwner,
                delete: isOwner
            },
            members: {
                invite: isOwner,
                update: isOwner,
                remove: isOwner
            },
            roles: {
                write: isOwner
            }
        }
    };
};
const useMyPermissions = (companySlug)=>{
    var _me_data;
    const me = shared_api__WEBPACK_IMPORTED_MODULE_3__/* .api.companyEmployee.useCompanyEmployeeMe */ .h.companyEmployee.useCompanyEmployeeMe(companySlug);
    const role = (_me_data = me.data) === null || _me_data === void 0 ? void 0 : _me_data.companyEmployeeRole;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>!role ? null : convertPermissions(role.type, role.permissions), [
        role
    ]);
};


/***/ }),

/***/ 59906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ CompanyLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/auth/model/auth-guard.model.tsx
var auth_guard_model = __webpack_require__(95244);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/company/entities/company/company-expired/company-expired.module.scss
var company_expired_module = __webpack_require__(60978);
var company_expired_module_default = /*#__PURE__*/__webpack_require__.n(company_expired_module);
;// CONCATENATED MODULE: ./src/modules/company/entities/company/company-expired/company-expired.tsx




const CompanyExpired = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((company_expired_module_default()).company_expired, props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (company_expired_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Для этой компании закончился период доступа"
            })
        })
    });
};
CompanyExpired.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/header-dashboard/header-dashboard.tsx + 13 modules
var header_dashboard = __webpack_require__(35622);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-navigation/header-navigation.tsx
var header_navigation = __webpack_require__(20168);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-title/header-title.tsx
var header_title = __webpack_require__(35629);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/pages/[company]/_layout.tsx








const CompanyLayout = (props)=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(companySlug);
    (0,auth_guard_model/* useGuardAuthedOnly */.T)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_dashboard/* HeaderDashboard */.w, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_navigation/* HeaderNavigation */.F, {
                menu: [
                    {
                        label: "Финансы",
                        href: _router/* default.company */.Z.company(companySlug).finances.href
                    },
                    // { label: "Департаменты", href: pages.company(companySlug).departments.href },
                    {
                        label: "Настройки",
                        href: _router/* default.company */.Z.company(companySlug).settings.href
                    }
                ],
                sticky: props.stickyNavigation
            }),
            company.data && !company.data.hasAccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyExpired, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_title/* HeaderTitle */.G, {
                        fullWidth: true,
                        back: props.back,
                        actions: props.actions,
                        children: props.title
                    }),
                    props.children
                ]
            })
        ]
    });
};
CompanyLayout.defaultProps = {
    stickyNavigation: true
};


/***/ }),

/***/ 10830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CompanySettingsLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47656);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6480);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8254);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59906);






const CompanySettingsLayout = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const slug = router.query.company;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_3__/* .CompanyLayout */ .q, {
        title: "Настройки",
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_4__/* .WithSidebarContainer */ .I, {
            mainHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
            sidebar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_6__/* .Sidebar */ .Y, {
                mainHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
                menu: [
                    {
                        label: "Общие",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
                        exact: true,
                        additionalHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.general.href
                    },
                    {
                        label: "Сотрудники",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.users.href
                    },
                    {
                        label: "Роли",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.roles.href
                    }
                ]
            }),
            children: props.children
        })
    });
};


/***/ }),

/***/ 81300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ general_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/my-permissions/use-my-permissions.ts
var use_my_permissions = __webpack_require__(80665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/lib/use-api-method.ts
var use_api_method = __webpack_require__(24453);
// EXTERNAL MODULE: ./src/shared/ui/fieldset/fieldset.tsx + 8 modules
var fieldset = __webpack_require__(73053);
// EXTERNAL MODULE: ./src/shared/ui/avatar-input/avatar-input.tsx
var avatar_input = __webpack_require__(43880);
;// CONCATENATED MODULE: ./src/modules/company/features/company-update/avatar/company-update-avatar-form.tsx







const CompanyAvatarForm = (props)=>{
    var _company_data, _company_data1, _company_data2, _company_data_avatarImage;
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.company.companyChangeAvatarImage */.h.company.companyChangeAvatarImage);
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug);
    const updateAvatar = async (value)=>{
        var _company_data, _company_data1;
        if (!((_company_data = company.data) === null || _company_data === void 0 ? void 0 : _company_data.id)) return;
        if (!value) return;
        await submit.call((_company_data1 = company.data) === null || _company_data1 === void 0 ? void 0 : _company_data1.id, {
            value
        });
        await company.mutate();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset */.p, {
            disabled: !(permissions === null || permissions === void 0 ? void 0 : permissions.company.general.update),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Content */.p.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_input/* AvatarInput */.P, {
                            id: (_company_data = company.data) === null || _company_data === void 0 ? void 0 : _company_data.id,
                            name: (_company_data1 = company.data) === null || _company_data1 === void 0 ? void 0 : _company_data1.name,
                            value: (_company_data2 = company.data) === null || _company_data2 === void 0 ? void 0 : (_company_data_avatarImage = _company_data2.avatarImage) === null || _company_data_avatarImage === void 0 ? void 0 : _company_data_avatarImage.id,
                            onChange: updateAvatar,
                            style: {
                                float: "right"
                            },
                            tabIndex: -1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Title */.p.Title, {
                            children: "Аватар"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Subtitle */.p.Subtitle, {
                            children: [
                                "Нажмите на него, чтобы загрузить файлы.",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Также вы можете",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: ()=>updateAvatar(undefined),
                                    tabIndex: -1,
                                    children: "удалить"
                                }),
                                " ",
                                "аватар."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer */.p.Footer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer.Status */.p.Footer.Status, {
                        children: [
                            !submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "Аватар опционален, но рекомендуется его установить"
                            }),
                            submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Error */.p.Error, {
                                children: submit.error.message
                            })
                        ]
                    })
                })
            ]
        })
    });
};
CompanyAvatarForm.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/input/input.tsx
var input = __webpack_require__(99088);
// EXTERNAL MODULE: ./src/shared/ui/button/button.tsx
var button_button = __webpack_require__(76780);
;// CONCATENATED MODULE: ./src/modules/company/features/company-update/name/company-update-name-form.tsx






const CompanyNameForm = (props)=>{
    var _company_data;
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug);
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.company.companyChangeName */.h.company.companyChangeName);
    const [value, setValue] = (0,react.useState)();
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!company.data || !value) return;
        await submit.call(company.data.id, {
            value
        });
        await company.mutate();
        setValue(undefined);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset */.p, {
            disabled: !(permissions === null || permissions === void 0 ? void 0 : permissions.company.general.update),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Content */.p.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Title */.p.Title, {
                            children: "Название компании"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Subtitle */.p.Subtitle, {
                            children: "Название вашей компании или филиала, которое вы и добавленные сотрудники будете видеть в списке компаний. Рекомендуем использовать брендовое, а не юридическое название."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            tabIndex: -1,
                            style: {
                                maxWidth: 300
                            },
                            name: "organization",
                            value: value !== null && value !== void 0 ? value : (_company_data = company.data) === null || _company_data === void 0 ? void 0 : _company_data.name,
                            onChange: (e)=>setValue(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer */.p.Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer.Status */.p.Footer.Status, {
                            children: [
                                !submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "Максимум 32 символа"
                                }),
                                submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Error */.p.Error, {
                                    children: submit.error.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Actions */.p.Footer.Actions, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                htmlType: "submit",
                                size: "small",
                                disabled: !value,
                                loading: submit.loading,
                                tabIndex: -1,
                                children: "Сохранить"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
CompanyNameForm.defaultProps = {};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./src/modules/company/features/company-update/slug/company-update-slug-form.tsx






const CompanySlugForm = (props)=>{
    var _company_data;
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug);
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(props.companySlug);
    const [value, setValue] = (0,react.useState)();
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!company.data || !value) return;
        await init/* api.company.companyChangeSlug */.h.company.companyChangeSlug(company.data.id, {
            value
        });
        await company.mutate();
        await router_default().replace({
            query: {
                ...(router_default()).query,
                company: value
            }
        });
        setValue(undefined);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset */.p, {
            disabled: !(permissions === null || permissions === void 0 ? void 0 : permissions.company.general.update),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Content */.p.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Title */.p.Title, {
                            children: "Ссылка на компанию"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Subtitle */.p.Subtitle, {
                            children: "Можете задать уникальную ссылку для своей компании. Она будет видна в части ссылки для приглашения сотрудников."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                            style: {
                                maxWidth: 300
                            },
                            prefix: "control.online/",
                            value: value !== null && value !== void 0 ? value : (_company_data = company.data) === null || _company_data === void 0 ? void 0 : _company_data.slug,
                            onChange: (e)=>setValue(e.target.value),
                            tabIndex: -1
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer */.p.Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Status */.p.Footer.Status, {
                            children: "Максимум 48 символов"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Actions */.p.Footer.Actions, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                size: "small",
                                htmlType: "submit",
                                disabled: !value,
                                tabIndex: -1,
                                children: "Сохранить"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
CompanySlugForm.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/lib/format-date.ts
var format_date = __webpack_require__(68984);
// EXTERNAL MODULE: ./src/shared/ui/modal/modal.tsx + 7 modules
var modal = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/shared/ui/entity/entity.tsx + 3 modules
var entity = __webpack_require__(51978);
// EXTERNAL MODULE: ./src/shared/ui/avatar/avatar.tsx
var avatar = __webpack_require__(57233);
// EXTERNAL MODULE: ./src/shared/ui/error/error.tsx
var error = __webpack_require__(64871);
// EXTERNAL MODULE: ./src/shared/ui/loading-dots/loading-dots.tsx
var loading_dots = __webpack_require__(42966);
;// CONCATENATED MODULE: ./src/modules/company/features/company-delete/company-delete-modal.tsx





const CompanyDeleteModal = (props)=>{
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.company.companyArchive */.h.company.companyArchive);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.data.id);
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 450,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Удаление компании"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity */.J, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                    ...props.data,
                                    size: 39
                                }),
                                title: props.data.name,
                                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Создана ",
                                        (0,format_date/* formatDate */.p6)(props.data.createdAt)
                                    ]
                                })
                            })
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Отмена"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Удалить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Удаление"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
CompanyDeleteModal.defaultProps = {};

// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/lib/use-modal.tsx
var use_modal = __webpack_require__(74363);
;// CONCATENATED MODULE: ./src/modules/company/features/company-delete/company-delete-form.tsx









const CompanyDeleteForm = (props)=>{
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug);
    const companyList = init/* api.company.useCompanyList */.h.company.useCompanyList();
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(props.companySlug);
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!company.data) return;
        use_modal/* Modals.open */.nK.open(CompanyDeleteModal, {
            data: company.data,
            onSuccess: async ()=>{
                await companyList.mutate();
                await router_default().replace(_router/* default.dashboard.href */.Z.dashboard.href);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        onSubmit: onSubmit,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset */.p, {
            type: "error",
            disabled: !(permissions === null || permissions === void 0 ? void 0 : permissions.company.general.delete),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Content */.p.Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Title */.p.Title, {
                            children: "Удаление компании"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Subtitle */.p.Subtitle, {
                            children: "Компания исчезнет, восстановить ее будет нельзя"
                        }),
                        company.data && /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity */.J, {
                            style: {
                                maxWidth: 450,
                                marginTop: 20
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                    ...company.data,
                                    size: 39
                                }),
                                title: company.data.name,
                                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Создана ",
                                        (0,format_date/* formatDate */.p6)(company.data.createdAt)
                                    ]
                                }),
                                width: 200
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(fieldset/* Fieldset.Footer */.p.Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Status */.p.Footer.Status, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fieldset/* Fieldset.Footer.Actions */.p.Footer.Actions, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                htmlType: "submit",
                                size: "small",
                                type: "error",
                                disabled: !company.data,
                                tabIndex: -1,
                                children: "Удалить"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
CompanyDeleteForm.defaultProps = {};

// EXTERNAL MODULE: ./src/pages/[company]/settings/_layout.tsx
var _layout = __webpack_require__(10830);
;// CONCATENATED MODULE: ./src/pages/[company]/settings/general.page.tsx





const CompanySettingsPage = ()=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_layout/* CompanySettingsLayout */.Q, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyAvatarForm, {
                companySlug: companySlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyNameForm, {
                companySlug: companySlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySlugForm, {
                companySlug: companySlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyDeleteForm, {
                companySlug: companySlug
            })
        ]
    });
};
/* harmony default export */ var general_page = (CompanySettingsPage);


/***/ }),

/***/ 68984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bh": function() { return /* binding */ formatMonth; },
/* harmony export */   "mr": function() { return /* binding */ formatTime; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30120);

const formatDateTime = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    const data = new Date(value);
    const opts = {
        // year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        ...options
    };
    if (data.getFullYear() === currentYear) {
        delete opts.year;
    }
    let result = data.toLocaleString("ru-RU", opts);
    if (opts.month === "short") {
        result = result.replace(".", "");
    }
    return result;
};
const formatTime = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    return new Date(value).toLocaleString("ru-RU", {
        hour: "2-digit",
        minute: "2-digit",
        ...options
    });
};
const currentYear = new Date().getFullYear();
const formatDate = function(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!value) return "";
    const data = new Date(value);
    const opts = {
        // year: "numeric",
        month: "short",
        day: "2-digit",
        ...options
    };
    if (data.getFullYear() === currentYear) {
        delete opts.year;
    }
    let result = data.toLocaleString("ru-RU", opts);
    if (opts.month === "short") {
        result = result.replace("марта", "мар").replace("февр.", "фев").replace(".", "");
    }
    return result;
};
const formatMonth = (month)=>{
    if (month === undefined || month === null) return;
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.local */ .ou.local(2000, Number(month)).setLocale("ru").toLocaleString({
        month: "long"
    });
};


/***/ }),

/***/ 51978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Entity; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/ui/entity/entity-menu-context.tsx

const EntityMenuContext = /*#__PURE__*/ react.createContext(null);

// EXTERNAL MODULE: ./src/shared/ui/icon/dots-vertical.svg
var dots_vertical = __webpack_require__(92039);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/container/menu-container.tsx
var menu_container = __webpack_require__(8581);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/button/menu-button.tsx
var menu_button = __webpack_require__(92422);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/menu/menu.tsx
var menu = __webpack_require__(78024);
// EXTERNAL MODULE: ./src/shared/ui/entity/actions/entity-actions.module.scss
var entity_actions_module = __webpack_require__(3115);
var entity_actions_module_default = /*#__PURE__*/__webpack_require__.n(entity_actions_module);
;// CONCATENATED MODULE: ./src/shared/ui/entity/actions/entity-actions.tsx







const EntityActions = (props)=>{
    const menuItems = (0,react.useContext)(EntityMenuContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_actions_module_default()).entity_actions, props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            props.children,
            menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_actions_module_default()).menu_button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                    placement: "bottom-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                            size: "small",
                            svgOnly: true,
                            variant: "unstyled",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                            minWidth: 150,
                            children: menuItems
                        })
                    ]
                })
            })
        ]
    });
};
EntityActions.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/entity/entity.module.scss
var entity_module = __webpack_require__(68404);
var entity_module_default = /*#__PURE__*/__webpack_require__.n(entity_module);
// EXTERNAL MODULE: ./src/shared/ui/entity/field/entity-field.module.scss
var entity_field_module = __webpack_require__(38244);
var entity_field_module_default = /*#__PURE__*/__webpack_require__.n(entity_field_module);
;// CONCATENATED MODULE: ./src/shared/ui/entity/field/entity-field.tsx







const EntityField = (props)=>{
    const style = (0,react.useMemo)(()=>{
        const width = typeof props.width === "number" ? props.width + "px" : props.width;
        if (!width) {
            return props.style;
        } else {
            return {
                ...props.style,
                flex: "0 0 ".concat(width)
            };
        }
    }, [
        props.style,
        props.width
    ]);
    const menuItems = (0,react.useContext)(EntityMenuContext);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_field_module_default()).entity_field, props.flex && (entity_field_module_default()).flex, props.right && (entity_field_module_default()).right, props.label && (entity_field_module_default()).label, props.className),
        style: style,
        id: props.htmlId,
        children: [
            props.avatar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: props.avatar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((entity_field_module_default()).content),
                id: props.htmlId,
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (entity_field_module_default()).title,
                        children: props.title
                    }),
                    props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (entity_field_module_default()).description,
                        children: props.description
                    }),
                    props.children
                ]
            }),
            menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_field_module_default()).menu_button,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_container/* MenuContainer */.F, {
                    placement: "bottom-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_button/* MenuButton */.j, {
                            size: "small",
                            svgOnly: true,
                            variant: "unstyled",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
                            minWidth: 150,
                            children: menuItems
                        })
                    ]
                })
            })
        ]
    });
};
EntityField.defaultProps = {};

;// CONCATENATED MODULE: ./src/shared/ui/entity/entity.tsx







const Entity = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((entity_module_default()).entity, props.hover && (entity_module_default()).hover, "entity", props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntityMenuContext.Provider, {
                value: props.menuItems,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (entity_module_default()).content,
                    style: {
                        "--flex": 1
                    },
                    children: [
                        props.checkbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(Entity.Field, {
                            width: 16,
                            children: props.checkbox
                        }),
                        props.children
                    ]
                })
            }),
            props.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (entity_module_default()).footer,
                children: props.footer
            })
        ]
    });
};
Entity.Field = EntityField;
Entity.Actions = EntityActions;
Entity.defaultProps = {};


/***/ }),

/***/ 60978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company_expired":"company-expired_company_expired__1K5vq","inner":"company-expired_inner__2NWWa"};

/***/ }),

/***/ 95571:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_navigation":"header-navigation_header_navigation__k37R9","sticky":"header-navigation_sticky__awsUq","menu":"header-navigation_menu__cb9yS","inner":"header-navigation_inner__OtSJ_","item":"header-navigation_item__FmE4u","active":"header-navigation_active__1bau7"};

/***/ }),

/***/ 3115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_actions":"entity-actions_entity_actions___FIaQ","menu_button":"entity-actions_menu_button__8wzDR"};

/***/ }),

/***/ 68404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity":"entity_entity__AWEQ3","content":"entity_content__7lRgo","entityMenu":"entity_entityMenu__m3g7R","footer":"entity_footer__7mvpx","hover":"entity_hover__ZZX8T"};

/***/ }),

/***/ 38244:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"entity_field":"entity-field_entity_field__QGeVR","content":"entity-field_content__xjWlB","title":"entity-field_title__nABa2","description":"entity-field_description__a2Fok","label":"entity-field_label__t3sOk","right":"entity-field_right__g1CEA","menu_button":"entity-field_menu_button__99rEj","flex":"entity-field_flex____qwg"};

/***/ })

}]);